<template>
  <div class="refused">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="17">
          <el-form-item label="退货">{{physicalFlag.goodsName}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="17">
          <el-form-item label="已用">{{form.usedNum}}次</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="17">
          <el-form-item label="剩余">12次</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="17">
          <el-form-item label="退货入库">
            <el-select
              v-model="form.warehouse"
              placeholder="请选择仓库"
              style="width:120px"
              v-if="physicalFlag.orderType==1 && relationFlag"
            >
              <el-option label="标准库" value="1" v-if="form.usedNum == 0"></el-option>
              <el-option label="公共库" value="2"></el-option>
            </el-select>
            <span v-else>{{relationFlag ? '仓库1':'无实体商品'}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :style="!relationFlag ? (physicalFlag.orderType==1 ? 'margin:20px 0':'margin:0 0 20px'):''">
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="17">
          <el-form-item label="退款" prop="price">
            <template v-if="relationFlag">￥198.00元</template>
            <template v-else>
              <el-input
                v-model="form.price"
                placeholder="请输入退款"
                style="width:120px"
                @blur="checkPrice"
              ></el-input>&nbsp;&nbsp;元
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="17">
          <el-form-item label="退货原因" prop="reason" :class="{'lineH': relationFlag}">
            <el-input
              type="textarea"
              v-model="form.reason"
              style="height:96px;"
              placeholder="请输入退货原因,50字以内"
              resize="none"
              v-if="!relationFlag"
            ></el-input>
            <span v-else>原因原因原因原因原因原因原因原因原因原因原因原因原因原因原因原因原因原因原因</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="17">
          <el-col
            class="Tips red"
          >{{physicalFlag.orderType == 1 ? '注意：线上订单，退款由平台原路退回，请勿重复退钱~' : '注意：门店订单，退款由门店自行退回。'}}</el-col>
        </el-col>
      </el-row>
      <el-row class="btnOptions">
        <template v-if="relationFlag">
          <el-button class="darkBtn" @click="closeDialog">关闭</el-button>
        </template>
        <template v-else>
          <el-button class="darkBtn" @click="resetData">取消</el-button>
          <el-button class="redBtn" @click="onSubmit" v-if="physicalFlag.orderType == 1">提交审核</el-button>
          <el-button class="redBtn" @click="onSubmit" v-else>确定</el-button>
        </template>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { insertStaff } from "@/api";

export default {
  props: ['actualPaid',"physicalFlag", "relationFlag"],
  data() {
    // 价格
    const isvalidateMoney = (rule, value, callback) => {
      if (Number(value)) {
        if (
          !Number.isInteger(Number(value)) &&
          value.toString().split(".")[1].length > 2
        ) {
          callback(new Error("不能超过两位小数"));
        } else if (Number(value) > 99999.99) {
          callback(new Error("金额最大99999.99"));
        } else if (Number(value) < 0) {
          callback(new Error("金额不能为负"));
        } else {
          callback();
        }
      } else if (!value || value == "") {
        callback();
      } else {
        callback(new Error("金额只能是数字，且保留两位小数"));
      }
    };
    return {
      form: {
        usedNum:0, //已用数量
        warehouse: '1',
        price: "",
        reason: ""
      },
      rules: {
        price: [{ type: "number", validator: isvalidateMoney }],
        reason: [
          {
            min: 0,
            max: 50,
            message: "长度在 50 个字符内",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    checkPrice() {
      //   校验退款金额与订单实付金额，大于提示“退款金额已超出订单实付金额！”
      //   第二次之后的退款金额，需要跟订单实付剩余金额做对比，大于提示“退款金额已超出订单剩余金额！”
      if(this.form.price > this.actualPaid){
        this.$message({
          message: '退款金额已超出订单实付金额！',
          type: 'warning'
        });
      }
    },
    closeDialog() {
      // 关闭弹窗
      this.$emit("closeDialog", false);
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.postId != 0) {
            delete this.form.staffLevel;
          }
          insertStaff(this.form).then(res => {
            if (res.code == 1) {
              // 关闭当前进入列表页
              this.$store.commit("setAliveStatus", true); //保留列表页状态
              this.$router.push("/basicDataCenter/employeeBasicInfo");
            }
            this.$message({
              type: res.code == 1 ? "success" : "error",
              message: res.msg
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetData() {
      this.$confirm(
        "确定要取消本次编辑的信息吗？取消后本次编辑的内容不保存",
        "提示",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "继续编辑",
          cancelButtonText: "确定取消",
          type: "warning"
        }
      )
        .then(() => {})
        .catch(action => {
          if (action === "cancel") {
            this.$message({
              type: "info",
              message: "已取消"
            });
            this.$refs.form.resetFields();
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.refused {
  width: 100%;
  overflow: hidden;
  text-align: center;
  .seize {
    height: 20px;
  }
  .Tips {
    margin-top: 20px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
<style lang="less">
.refused {
  .lineH {
    .el-form-item__content {
      line-height: 25px;
      padding-top:8px;
    }
  }
  .el-form-item__content {
    text-align: left;
  }
  .el-input__inner {
    height: 35px;
    line-height: 35px;
  }
  .btnOptions {
    margin-top: 50px;
    text-align: center;
    .el-button {
      width: 105px;
      height: 38px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/businessManagementCenter/refused.vue